module.exports = __webpack_public_path__ + "img/application-leather.512abd4c.jpg";